import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { DeltaSource } from 'app/model/pipeline/copysource/delta.source';
import { convertStoreSettingsToResource, convertStoreSettingsToModel } from './store-read-settings/store-read-settings.util';
import { convertFormatSettingsToResource, convertFormatSettingsToModel } from './format-read-settings/format-read-settings.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DeltaSource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        storeSettings: '*',
        formatSettings: '*'
    }
})
export class DeltaSourceAdapter extends CopySourceAdapter<DeltaSource, Model.DeltaSource> {

    protected override async _toResource(copySource: DeltaSource): Promise<Model.DeltaSource> {
        const result: Model.DeltaSource = this.getCommonCopySourceProperties(copySource, 'DeltaSource');

        await convertStoreSettingsToResource(copySource.storeSettings, result, this.context);
        if (result.storeSettings != null) {
            // Delta enumerates the table through its transaction log, not file-level selectors.
            for (const property of [
                'wildcardFolderPath',
                'wildcardFileName',
                'fileListPath',
                'enablePartitionDiscovery',
                'partitionRootPath',
                'modifiedDatetimeStart',
                'modifiedDatetimeEnd',
                'deleteFilesAfterCompletion',
                'fileName',
                'recursive'
            ]) {
                Reflect.deleteProperty(result.storeSettings, property);
            }
        }
        await convertFormatSettingsToResource(copySource.formatSettings, result, this.context);

        return result;
    }

    protected override async _toModel(source: Model.DeltaSource, copyActivity: CopyActivity): Promise<DeltaSource> {
        const result = this.createCopySourceWithCommonProperties(DeltaSource.MODEL, source, copyActivity) as DeltaSource;

        await convertStoreSettingsToModel(source.storeSettings, result, this.context);
        await convertFormatSettingsToModel(source.formatSettings, result, this.context);
        
        return result;
    }
}
